<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>审批</el-breadcrumb-item>
      <el-breadcrumb-item>费用报销/差旅费报销</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-date-picker v-model="keywords.begintime" type="date" placeholder="选择开始日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.endtime" type="date" placeholder="选择结束日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <RsljigouInternal :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigouInternal"></RsljigouInternal>
          </el-form-item>
          <el-form-item label="">
            <ChooseMultiErpUsersV2 ref="MultiErpUsers" @change="changeMultiErpUsers"></ChooseMultiErpUsersV2>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.fytype" placeholder="请选择" style="width: 100%">
              <el-option label="请选择费用类别" value="0"></el-option>
              <el-option label="差旅费" value="100"></el-option>
              <el-option label="招待费" value="1"></el-option>
              <el-option label="办公费" value="2"></el-option>
              <el-option label="税费" value="3"></el-option>
              <el-option label="水电费" value="4"></el-option>
              <el-option label="租赁费" value="5"></el-option>
              <el-option label="其他" value="6"></el-option>
              <el-option label="运输快递费" value="7"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.spstatus" placeholder="请选择" style="width: 100%">
              <el-option label="请选择审批状态" value="-1"></el-option>
              <el-option label="审批不通过" value="0"></el-option>
              <el-option label="待部门主管审核" value="1"></el-option>
              <el-option label="待财务主管审核" value="2"></el-option>
              <el-option label="待副总经理审核" value="3"></el-option>
              <el-option label="待总经理审核" value="4"></el-option>
              <el-option label="审批通过" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.printstatus" placeholder="请选择" style="width: 100%">
              <el-option label="请选择打印状态" value="-1"></el-option>
              <el-option label="未打印" value="0"></el-option>
              <el-option label="已打印" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.reason" @keyup.enter.native="clicksearch" placeholder="请输入事由" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.beizhu" @keyup.enter.native="clicksearch" placeholder="请输入备注" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Createtime" label="发生日期" min-width="10%"></el-table-column>
          <el-table-column prop="Orderid" label="表单号" min-width="10%"></el-table-column>
          <el-table-column prop="Spstatusname" label="审核状态" min-width="6%">
            <template slot-scope="props">
              <span class="blue" style="margin-left: 0; margin-right: 5px;color: #48c9b0;" @click="cilckStatus(props.row)">{{props.row.Spstatusname}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="ShangJigouName" label="所属公司" min-width="10%"></el-table-column> -->
          <el-table-column prop="CurJigouName" label="申请部门" min-width="10%"></el-table-column>
          <el-table-column prop="Name1" label="经办人" min-width="5%"></el-table-column>
          <el-table-column prop="Fytypename" label="费用类别" min-width="5%"></el-table-column>
          <el-table-column prop="Reason" label="事由" min-width="12%"></el-table-column>
          <el-table-column prop="Money" label="含税金额" min-width="5%"></el-table-column>
          <el-table-column prop="Moneynotax" label="未税金额" min-width="5%"></el-table-column>
          <el-table-column prop="Moneytax" label="税金" min-width="5%"></el-table-column>
          <el-table-column prop="Beizhu" label="备注" min-width="5%"></el-table-column>
          <el-table-column prop="Spopinion" label="审批意见" min-width="5%"></el-table-column>
          <el-table-column prop="Spreply" label="意见答复" min-width="5%"></el-table-column>
          <el-table-column label="附件" min-width="8%">
            <template v-slot="scope">
              <el-button v-for="Attachment in scope.row.Attachments" type="text" @click="clickfile(Attachment)">附件</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="Printstatusname" label="打印状态" min-width="6%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="8%">
            <template v-slot="scope">
              <el-button v-if="scope.row.Spstatus == 0 && useriderp == scope.row.Createuserid" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickedit(scope.row)">修改</el-button>
              <el-button v-if="scope.row.Spstatus == 0 && useriderp == scope.row.Createuserid" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdel(scope.row)">删除</el-button>
              <el-button v-if="scope.row.Spstatus == 0 && useriderp == scope.row.Createuserid" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe0(scope.row)">再次提交审核</el-button>
              <el-button v-if="scope.row.Spstatus == 1 && SubRule_ShenPiNewFyBxChaiLv_BuMen" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe1234(scope.row,1)">部门主管审核</el-button>
              <el-button v-if="scope.row.Spstatus == 2 && SubRule_ShenPiNewFyBxChaiLv_CaiWu" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe1234(scope.row,2)">财务审核</el-button>
              <el-button v-if="scope.row.Spstatus == 3 && SubRule_ShenPiNewFyBxChaiLv_FuZong" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe1234(scope.row,3)">副总经理审核</el-button>
              <el-button v-if="scope.row.Spstatus == 4 && SubRule_ShenPiNewFyBxChaiLv_Zong" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe1234(scope.row,4)">总经理审核</el-button>
              <el-button v-if="scope.row.Spstatus == 5 && SubRule_ShenPiNewFyBxChaiLv_Print" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdialogprint(scope.row)">打印</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickView(scope.row)">查看单据</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 审批 start -->
        <el-dialog
          title=""
          :visible.sync="dialogShenPi"
          width="880px">
          <printfeiyongbaoxiao v-if="selectfytype < 100" ref="ShenPiViewfeiyongbaoxiao"></printfeiyongbaoxiao>
          <printchailvfei v-if="selectfytype == 100" ref="ShenPiViewchailvfei"></printchailvfei>
          <el-form :model="modelShenPi" ref="modelShenPi" label-width="170px">
            <el-form-item label="税金" class="addAdminForm" v-if="modelShenPi.iscaiwushenpi">
              <el-input v-model="modelShenPi.moneytax"></el-input>
            </el-form-item>
            <el-form-item label="审批意见(可选)" class="addAdminForm">
              <el-input v-model="modelShenPi.spopinion" placeholder="如果拒绝,请填写审批意见"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="ShenHeOK">同意</el-button>
              <el-button type="danger" @click="ShenHeNO">拒绝</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 审批 end -->

        <el-dialog
          title="再次提交审核"
          :visible.sync="dialogSubmitAgain"
          width="35%">
          <el-form :model="modelSubmitAgain" ref="modelSubmitAgain" label-width="170px">
            <el-form-item label="答复审批意见" class="addAdminForm">
              <el-input v-model="modelSubmitAgain.spreply" placeholder="请填写答复"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="SubmitAgain">提交</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加费用报销" name="second">
      <el-form :model="addFormfeiyongbaoxiao" ref="addFormfeiyongbaoxiaoRef" label-width="170px">
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">费用类别(必选)</span>
          </label>
          <el-select v-model="addFormfeiyongbaoxiao.fytype" placeholder="请选择" style="width: 100%">
            <el-option label="请选择" value="0"></el-option>
            <el-option label="招待费" value="1"></el-option>
            <el-option label="办公费" value="2"></el-option>
            <el-option label="税费" value="3"></el-option>
            <el-option label="水电费" value="4"></el-option>
            <el-option label="租赁费" value="5"></el-option>
            <el-option label="其他" value="6"></el-option>
            <el-option label="运输快递费" value="7"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">收款单位(必填)</span>
          </label>
          <el-input v-model="addFormfeiyongbaoxiao.shoukuandanwei"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">银行账号(必填)</span>
          </label>
          <el-input v-model="addFormfeiyongbaoxiao.yinhangzhanghao"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">开户行(必填)</span>
          </label>
          <el-input v-model="addFormfeiyongbaoxiao.kaihuhang"></el-input>
        </el-form-item>
        <el-form-item label="垫付人(可选)" class="addAdminForm">
          <el-input v-model="addFormfeiyongbaoxiao.dianfuren" placeholder="如果垫付了费用,此处必填"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">付款原因(必填)</span>
          </label>
          <el-input v-model="addFormfeiyongbaoxiao.reason"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">金额(必填)</span>
          </label>
          <el-input v-model="addFormfeiyongbaoxiao.money"></el-input>
        </el-form-item>
        <el-form-item label="备注(可选)" class="addAdminForm">
          <el-input v-model="addFormfeiyongbaoxiao.beizhu"></el-input>
        </el-form-item>
        <el-form-item label="附件(可选)" class="addAdminForm">
          <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="addTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickaddfeiyongbaoxiao">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加差旅费报销" name="three">
      <el-form :model="addFormchailvfei" ref="addFormchailvfei" label-width="170px">
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">出差事由(必填)</span>
          </label>
          <el-input v-model="addFormchailvfei.reason"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">出差日期起(必填)</span>
          </label>
          <el-input v-model="addFormchailvfei.ccdaybegin"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">出差日期讫(必填)</span>
          </label>
          <el-input v-model="addFormchailvfei.ccdayend"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">总天数(必填)</span>
          </label>
          <el-input v-model="addFormchailvfei.ccdays"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">附件张数(必填)</span>
          </label>
          <el-input v-model="addFormchailvfei.ccattachmentnum"></el-input>
        </el-form-item>
        <el-form-item class="addAdminFormLLL">
          <label slot="label">
            <span style="color: #FF0000;">填写明细(必填)</span>
          </label>
          <div class="productdata1">
            <div class="productdata2">
              日期(月):
              <el-input v-model="addFormchailvfeisub.datemonth" style="width: 10%"></el-input>
              日期(日):
              <el-input v-model="addFormchailvfeisub.dateday" style="width: 10%"></el-input>
              起始地点:
              <el-input v-model="addFormchailvfeisub.addressbegin" style="width: 10%"></el-input>
              到达终点:
              <el-input v-model="addFormchailvfeisub.addressend" style="width: 10%"></el-input>
              天数:
              <el-input v-model="addFormchailvfeisub.days" style="width: 10%"></el-input>
            </div>
          </div>
          <div class="productdata1">
            <div class="productdata2">
              火车/机票:
              <el-input v-model="addFormchailvfeisub.huochejipiao" style="width: 10%"></el-input>
              交通费:
              <el-input v-model="addFormchailvfeisub.jiaotongfei" style="width: 10%"></el-input>
              住宿费:
              <el-input v-model="addFormchailvfeisub.zhusufei" style="width: 10%"></el-input>
              补贴:
              <el-input v-model="addFormchailvfeisub.butie" style="width: 10%"></el-input>
              其他:
              <el-input v-model="addFormchailvfeisub.qita" style="width: 10%"></el-input>
              <el-button type="text" @click="clickaddchailvfeisub()">增加</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="addAdminFormLLL">
          <label slot="label">
            <span style="color: #FF0000;">明细记录(必填)</span>
          </label>
          <el-card v-for="item,index in addFormchailvfei.chailvfeisub" :key="index">
            <li>日期(月)：{{item.datemonth}}；日期(日)：{{item.dateday}}；起始地点：{{item.addressbegin}}；到达终点：{{item.addressend}}；天数：{{item.days}}</li>
            <li>火车/机票：{{item.huochejipiao}}；交通费：{{item.jiaotongfei}}；住宿费：{{item.zhusufei}}；补贴：{{item.butie}}；其他：{{item.qita}}；小计：{{item.xiaoji}}</li>
            <el-button type="text" @click="clickdeletechailvfeisub(index)">删除</el-button>
          </el-card>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">金额(必填)</span>
          </label>
          <el-input v-model="addFormchailvfei.money" disabled></el-input>
        </el-form-item>
        <el-form-item label="预支(可选)" class="addAdminForm">
          <el-input v-model="addFormchailvfei.ccyuzhi"></el-input>
        </el-form-item>
        <el-form-item label="退/补(可选)" class="addAdminForm">
          <el-input v-model="addFormchailvfei.cctuibu"></el-input>
        </el-form-item>
        <el-form-item label="备注(可选)" class="addAdminForm">
          <el-input v-model="addFormchailvfei.beizhu"></el-input>
        </el-form-item>
        <el-form-item label="附件(可选)" class="addAdminForm">
          <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="addTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickaddFormchailvfei">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

    <!-- start -->
    <el-tab-pane label="修改费用报销" name="four" disabled="disabled">
      <ShenPiNewFyBxChaiLvEditFeiYong ref="SubVuefour" v-on:triggerFunc="BackToFirst"></ShenPiNewFyBxChaiLvEditFeiYong>
    </el-tab-pane>
    <!-- end -->

    <!-- start -->
    <el-tab-pane label="修改差旅费报销" name="five" disabled="disabled">
      <ShenPiNewFyBxChaiLvEditChaiLv ref="SubVuefive" v-on:triggerFunc="BackToFirst"></ShenPiNewFyBxChaiLvEditChaiLv>
    </el-tab-pane>
    <!-- end -->

    <el-dialog
      title=""
      :visible.sync="dialogPrint"
      width="880px">
      <div id="printAreaName">
        <printfeiyongbaoxiao v-if="selectfytype < 100" ref="PrintViewfeiyongbaoxiao"></printfeiyongbaoxiao>
        <printchailvfei v-if="selectfytype == 100" ref="PrintViewchailvfei"></printchailvfei>
      </div>
      <el-button type="success" v-print="`#printAreaName`">打印</el-button>
      <el-button type="success" @click="apiShenPiNewFyBxChaiLvPrint">设置为已经打印</el-button>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="dialogView"
      width="880px">
      <printfeiyongbaoxiao v-if="selectfytype < 100" ref="PrintViewfeiyongbaoxiao"></printfeiyongbaoxiao>
      <printchailvfei v-if="selectfytype == 100" ref="PrintViewchailvfei"></printchailvfei>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="dialogLog"
      width="400px">
        <el-timeline :reverse="dialogLogReverse">
          <el-timeline-item
            v-for="(activity, index) in dialogLogActivities"
            :key="index"
            :timestamp="activity.Createtime">
            {{activity.Content}}
          </el-timeline-item>
        </el-timeline>
    </el-dialog>

  </el-tabs>
  </div>
</template>

<script>
import printfeiyongbaoxiao from '@/componentsprint/printfeiyongbaoxiao.vue'
import printchailvfei from '@/componentsprint/printchailvfei.vue'
import RsljigouInternal from '@/components/RsljigouInternal.vue'
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
import ChooseMultiErpUsersV2 from '@/components/ChooseMultiErpUsersV2.vue'
import ShenPiNewFyBxChaiLvEditFeiYong from '@/componentsSubVue/ShenPiNewFyBxChaiLvEditFeiYong.vue'
import ShenPiNewFyBxChaiLvEditChaiLv from '@/componentsSubVue/ShenPiNewFyBxChaiLvEditChaiLv.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    printfeiyongbaoxiao,
    printchailvfei,
    RsljigouInternal,
    TencentyunCosUploadMultiImgOrPdf,
    ChooseMultiErpUsersV2,
    ShenPiNewFyBxChaiLvEditFeiYong,
    ShenPiNewFyBxChaiLvEditChaiLv
  },
  name: 'MyShenPiNewFyBxChaiLv',
  data () {
    return {
      useriderp: 0,
      activeName: 'first',
      addFormfeiyongbaoxiao: {
        fytype: '0',
        shoukuandanwei: '',
        yinhangzhanghao: '',
        kaihuhang: '',
        dianfuren: '',
        reason: '',
        money: '',
        beizhu: '',
        attachment: ''
      },
      addFormchailvfei: {
        reason: '',
        ccdaybegin: '',
        ccdayend: '',
        ccdays: '',
        ccattachmentnum: '',
        chailvfeisub: [],
        money: 0,
        ccyuzhi: '',
        cctuibu: '',
        beizhu: '',
        attachment: ''
      },
      addFormchailvfeisub: {
        datemonth: '',
        dateday: '',
        addressbegin: '',
        addressend: '',
        days: '',
        huochejipiao: 0,
        jiaotongfei: 0,
        zhusufei: 0,
        butie: 0,
        qita: 0,
        xiaoji: 0
      },
      modelShenPi: {
        spid: 0,
        spopinion: '',
        iscaiwushenpi: false,
        moneytax: ''
      },
      modelSubmitAgain: {
        spid: 0,
        spreply: ''
      },
      // 查询
      keywords: {
        begintime: '',
        endtime: '',
        jigouid: '-1',
        jigouname: '',
        createuserid: 0,
        fytype: '0',
        spstatus: '-1',
        orderidcaigou: '',
        shoukuandanwei: '',
        printstatus: '-1',
        reason: '',
        beizhu: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      dialogShenPi: false,
      selectfytype: 0,
      dialogSubmitAgain: false,
      apiShenPiBaoXiaoSHUrl: '',
      SubRule_ShenPiNewFyBxChaiLv_BuMen: false,
      SubRule_ShenPiNewFyBxChaiLv_CaiWu: false,
      SubRule_ShenPiNewFyBxChaiLv_FuZong: false,
      SubRule_ShenPiNewFyBxChaiLv_Zong: false,
      SubRule_ShenPiNewFyBxChaiLv_Print: false,
      dialogPrint: false,
      dialogView: false,
      dialogLog: false,
      dialogLogReverse: true,
      dialogLogActivities: [{
        content: '活动按期开始',
        timestamp: '2018-04-15'
      }, {
        content: '通过审核',
        timestamp: '2018-04-13'
      }, {
        content: '创建成功',
        timestamp: '2018-04-11'
      }]
    }
  },
  mounted () {
    this.useriderp = localStorage.getItem('Useriderp')
    this.apiGetShenPiNewFyBxChaiLvNum()
    this.apiGetShenPiNewFyBxChaiLvList()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiNewFyBxChaiLv_BuMen', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiNewFyBxChaiLv_BuMen = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiNewFyBxChaiLv_CaiWu', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiNewFyBxChaiLv_CaiWu = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiNewFyBxChaiLv_FuZong', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiNewFyBxChaiLv_FuZong = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiNewFyBxChaiLv_Zong', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiNewFyBxChaiLv_Zong = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiNewFyBxChaiLv_Print', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiNewFyBxChaiLv_Print = true
      }
    })
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetShenPiNewFyBxChaiLvNum()
      this.apiGetShenPiNewFyBxChaiLvList()
    },
    addTencentyunCosUploadMultiImgOrPdf (url) {
      this.addFormfeiyongbaoxiao.attachment = url
      this.addFormchailvfei.attachment = url
    },
    changeRsljigouInternal (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    changeMultiErpUsers (rv) {
      this.keywords.createuserid = rv
    },
    clickfile (url) {
      Vue.prototype.FunReviewFileurl(url, this.$router)
    },
    clickdialogprint (row) {
      this.modelSubmitAgain.spid = row.Id

      this.selectfytype = row.Fytype
      this.dialogPrint = true
      var that = this
      var forprint = 1
      this.$nextTick(() => {
        if (that.selectfytype < 100) {
          that.$refs.PrintViewfeiyongbaoxiao.LoadData(row, forprint)
        } else {
          that.$refs.PrintViewchailvfei.LoadData(row, forprint)
        }
      })
    },
    clickView (row) {
      this.selectfytype = row.Fytype
      this.dialogView = true
      var that = this
      var forprint = 0
      this.$nextTick(() => {
        if (that.selectfytype < 100) {
          that.$refs.PrintViewfeiyongbaoxiao.LoadData(row, forprint)
        } else {
          that.$refs.PrintViewchailvfei.LoadData(row, forprint)
        }
      })
    },
    cilckStatus(row){
      this.dialogLog = true
      this.apiGetShenPiNewFyBxChaiLvLogList(row.Orderid)
    },
    clickedit (row) {
      var that = this
      if (row.Fytype < 100) {
        // 修改费用报销
        that.activeName = 'four'
        that.$refs.SubVuefour.LoadData(row)
      } else {
        // 修改差旅费报销
        that.activeName = 'five'
        that.$refs.SubVuefive.LoadData(row)
      }
    },
    clickadd () {
      this.apiAddShenPiBaoXiao()
    },
    clickaddfeiyongbaoxiao () {
      if (this.addFormfeiyongbaoxiao.fytype <= 0) {
        Vue.prototype.FunAlertMsg('请选择费用类别')
        return
      }
      if (this.addFormfeiyongbaoxiao.shoukuandanwei.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入收款单位')
        return
      }
      if (this.addFormfeiyongbaoxiao.yinhangzhanghao.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入银行账号')
        return
      }
      if (this.addFormfeiyongbaoxiao.kaihuhang.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入开户行')
        return
      }
      if (this.addFormfeiyongbaoxiao.reason.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入付款原因')
        return
      }
      if (!Vue.prototype.FunCheckNumber(this.addFormfeiyongbaoxiao.money)) {
        Vue.prototype.FunAlertMsg('请输入金额')
        return
      }
      this.apiAddShenPiNewFyBxChaiLv1()
    },
    clickaddFormchailvfei () {
      if (this.addFormchailvfei.reason.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入出差事由')
        return
      }
      if (this.addFormchailvfei.ccdaybegin.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入出差日期起')
        return
      }
      if (this.addFormchailvfei.ccdayend.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入出差日期讫')
        return
      }
      if (this.addFormchailvfei.ccdays.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入总天数')
        return
      }
      if (this.addFormchailvfei.ccattachmentnum.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入附件张数')
        return
      }
      if (this.addFormchailvfei.chailvfeisub.length < 1) {
        Vue.prototype.FunAlertMsg('请填写明细')
        return
      }
      if (!Vue.prototype.FunCheckNumber(this.addFormchailvfei.money)) {
        Vue.prototype.FunAlertMsg('请输入金额')
        return
      }
      this.apiAddShenPiNewFyBxChaiLv2()
    },
    clickaddchailvfeisub () {
      if (this.addFormchailvfei.chailvfeisub.length >= 6) {
        Vue.prototype.FunAlertMsg('明细最多6条')
        return
      }
      if (this.addFormchailvfeisub.datemonth.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入日期(月)')
        return
      }
      if (this.addFormchailvfeisub.dateday.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入日期(日)')
        return
      }
      if (this.addFormchailvfeisub.addressbegin.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入起始地点')
        return
      }
      if (this.addFormchailvfeisub.addressend.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入到达终点')
        return
      }
      if (this.addFormchailvfeisub.days.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入天数')
        return
      }
      if (!Vue.prototype.FunCheckNumber(this.addFormchailvfeisub.huochejipiao)) {
        Vue.prototype.FunAlertMsg('请输入火车/机票')
        return
      }
      if (!Vue.prototype.FunCheckNumber(this.addFormchailvfeisub.jiaotongfei)) {
        Vue.prototype.FunAlertMsg('请输入交通费')
        return
      }
      if (!Vue.prototype.FunCheckNumber(this.addFormchailvfeisub.zhusufei)) {
        Vue.prototype.FunAlertMsg('请输入住宿费')
        return
      }
      if (!Vue.prototype.FunCheckNumber(this.addFormchailvfeisub.butie)) {
        Vue.prototype.FunAlertMsg('请输入补贴')
        return
      }
      if (!Vue.prototype.FunCheckNumber(this.addFormchailvfeisub.qita)) {
        Vue.prototype.FunAlertMsg('请输入其他')
        return
      }
      this.addFormchailvfeisub.xiaoji = parseFloat(this.addFormchailvfeisub.huochejipiao) + parseFloat(this.addFormchailvfeisub.jiaotongfei) + parseFloat(this.addFormchailvfeisub.zhusufei) + parseFloat(this.addFormchailvfeisub.butie) + parseFloat(this.addFormchailvfeisub.qita)

      this.addFormchailvfei.chailvfeisub.push({
        datemonth: this.addFormchailvfeisub.datemonth,
        dateday: this.addFormchailvfeisub.dateday,
        addressbegin: this.addFormchailvfeisub.addressbegin,
        addressend: this.addFormchailvfeisub.addressend,
        days: this.addFormchailvfeisub.days,
        huochejipiao: parseFloat(this.addFormchailvfeisub.huochejipiao),
        jiaotongfei: parseFloat(this.addFormchailvfeisub.jiaotongfei),
        zhusufei: parseFloat(this.addFormchailvfeisub.zhusufei),
        butie: parseFloat(this.addFormchailvfeisub.butie),
        qita: parseFloat(this.addFormchailvfeisub.qita),
        xiaoji: this.addFormchailvfeisub.xiaoji
      })
      this.countchailvfeiMoney()
    },
    clickdeletechailvfeisub (index) {
      var buflist = []
      for (var j = 0, len = this.addFormchailvfei.chailvfeisub.length; j < len; j++) {
        if (index != j) {
          buflist.push(this.addFormchailvfei.chailvfeisub[j])
        }
      }
      this.addFormchailvfei.chailvfeisub = buflist
      this.countchailvfeiMoney()
    },
    countchailvfeiMoney () {
      this.addFormchailvfei.money = 0
      for (var j = 0, len = this.addFormchailvfei.chailvfeisub.length; j < len; j++) {
        this.addFormchailvfei.money += this.addFormchailvfei.chailvfeisub[j].xiaoji
      }
    },
    clickreturn () {
      this.activeName = 'first'
    },
    ShenHe0 (row) {
      this.dialogSubmitAgain = true
      this.apiShenPiBaoXiaoSHUrl = Vue.prototype.global.Url_ShenPiNewFyBxChaiLvSH0
      this.modelSubmitAgain.spid = row.Id
      this.modelSubmitAgain.spreply = ''
    },
    ShenHe1234 (row, number) {
      this.dialogShenPi = true
      this.modelShenPi.spid = row.Id
      this.modelShenPi.spopinion = ''
      this.modelShenPi.iscaiwushenpi = false
      this.modelShenPi.moneytax = '0'
      if (number === 1) {
        this.apiShenPiBaoXiaoSHUrl = Vue.prototype.global.Url_ShenPiNewFyBxChaiLvSH1
      }
      if (number === 2) {
        this.modelShenPi.iscaiwushenpi = true
        this.apiShenPiBaoXiaoSHUrl = Vue.prototype.global.Url_ShenPiNewFyBxChaiLvSH2
      }
      if (number === 3) {
        this.apiShenPiBaoXiaoSHUrl = Vue.prototype.global.Url_ShenPiNewFyBxChaiLvSH3
      }
      if (number === 4) {
        this.apiShenPiBaoXiaoSHUrl = Vue.prototype.global.Url_ShenPiNewFyBxChaiLvSH4
      }
      this.selectfytype = row.Fytype

      var that = this
      var forprint = 0
      this.$nextTick(() => {
        if (that.selectfytype < 100) {
          that.$refs.ShenPiViewfeiyongbaoxiao.LoadData(row, forprint)
        } else {
          that.$refs.ShenPiViewchailvfei.LoadData(row, forprint)
        }
      })
    },
    ShenHeOK () {
      this.dialogShenPi = false
      this.apiShenPiBaoXiaoSH(1)
    },
    ShenHeNO () {
      this.dialogShenPi = false
      this.apiShenPiBaoXiaoSH(-1)
    },
    SubmitAgain () {
      this.dialogSubmitAgain = false
      this.apiShenPiNewFyBxChaiLvSH0()
    },
    clickdel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelShenPiNewFyBxChaiLv(row.Id)
      })
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetShenPiNewFyBxChaiLvNum()
      this.apiGetShenPiNewFyBxChaiLvList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetShenPiNewFyBxChaiLvList()
    },
    apiGetShenPiNewFyBxChaiLvNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        jigouid: that.keywords.jigouid,
        createuserid: that.keywords.createuserid,
        fytype: that.keywords.fytype,
        orderidcaigou: that.keywords.orderidcaigou,
        shoukuandanwei: that.keywords.shoukuandanwei,
        spstatus: that.keywords.spstatus,
        printstatus: that.keywords.printstatus,
        reason: that.keywords.reason,
        beizhu: that.keywords.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiNewFyBxChaiLvNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetShenPiNewFyBxChaiLvList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        jigouid: that.keywords.jigouid,
        createuserid: that.keywords.createuserid,
        fytype: that.keywords.fytype,
        orderidcaigou: that.keywords.orderidcaigou,
        shoukuandanwei: that.keywords.shoukuandanwei,
        spstatus: that.keywords.spstatus,
        printstatus: that.keywords.printstatus,
        reason: that.keywords.reason,
        beizhu: that.keywords.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiNewFyBxChaiLvList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
            for (var i = 0; i < that.dataList.length; i++) {
              that.dataList[i].Attachments = []
              if (that.dataList[i].Attachment.length > 1) {
                that.dataList[i].Attachments = that.dataList[i].Attachment.split('@@@')
              }
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddShenPiNewFyBxChaiLv1: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        fytype: that.addFormfeiyongbaoxiao.fytype,
        shoukuandanwei: that.addFormfeiyongbaoxiao.shoukuandanwei,
        yinhangzhanghao: that.addFormfeiyongbaoxiao.yinhangzhanghao,
        kaihuhang: that.addFormfeiyongbaoxiao.kaihuhang,
        dianfuren: that.addFormfeiyongbaoxiao.dianfuren,
        reason: that.addFormfeiyongbaoxiao.reason,
        money: that.addFormfeiyongbaoxiao.money,
        beizhu: that.addFormfeiyongbaoxiao.beizhu,
        attachment: that.addFormfeiyongbaoxiao.attachment
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddShenPiNewFyBxChaiLv1, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiNewFyBxChaiLvNum()
            that.apiGetShenPiNewFyBxChaiLvList()

            // 清空添加
            that.addFormfeiyongbaoxiao.fytype = '0'
            that.addFormfeiyongbaoxiao.shoukuandanwei = ''
            that.addFormfeiyongbaoxiao.yinhangzhanghao = ''
            that.addFormfeiyongbaoxiao.kaihuhang = ''
            that.addFormfeiyongbaoxiao.dianfuren = ''
            that.addFormfeiyongbaoxiao.reason = ''
            that.addFormfeiyongbaoxiao.money = ''
            that.addFormfeiyongbaoxiao.beizhu = ''
            that.addFormfeiyongbaoxiao.attachment = ''
            that.$refs.MultiImgOrPdf.cleardata()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddShenPiNewFyBxChaiLv2: function () {
      var bufchailvfeisub = []
      var bufhuochejipiao = 0
      var bufjiaotongfei = 0
      var bufzhusufei = 0
      var bufbutie = 0
      var bufqita = 0
      var bufxiaoji = 0
      for (var j = 0, len = this.addFormchailvfei.chailvfeisub.length; j < len; j++) {
        bufhuochejipiao += this.addFormchailvfei.chailvfeisub[j].huochejipiao
        bufjiaotongfei += this.addFormchailvfei.chailvfeisub[j].jiaotongfei
        bufzhusufei += this.addFormchailvfei.chailvfeisub[j].zhusufei
        bufbutie += this.addFormchailvfei.chailvfeisub[j].butie
        bufqita += this.addFormchailvfei.chailvfeisub[j].qita
        bufxiaoji += this.addFormchailvfei.chailvfeisub[j].xiaoji
        bufchailvfeisub.push(this.addFormchailvfei.chailvfeisub[j])
      }
      bufchailvfeisub.push({
        datemonth: '0',
        dateday: '0',
        addressbegin: '0',
        addressend: '0',
        days: '0',
        huochejipiao: bufhuochejipiao,
        jiaotongfei: bufjiaotongfei,
        zhusufei: bufzhusufei,
        butie: bufbutie,
        qita: bufqita,
        xiaoji: bufxiaoji
      })

      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        reason: that.addFormchailvfei.reason,
        ccdaybegin: that.addFormchailvfei.ccdaybegin,
        ccdayend: that.addFormchailvfei.ccdayend,
        ccdays: that.addFormchailvfei.ccdays,
        ccattachmentnum: that.addFormchailvfei.ccattachmentnum,
        chailvfeisub: JSON.stringify(bufchailvfeisub),
        money: that.addFormchailvfei.money,
        ccyuzhi: that.addFormchailvfei.ccyuzhi,
        cctuibu: that.addFormchailvfei.cctuibu,
        beizhu: that.addFormchailvfei.beizhu,
        attachment: that.addFormchailvfei.attachment
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddShenPiNewFyBxChaiLv2, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiNewFyBxChaiLvNum()
            that.apiGetShenPiNewFyBxChaiLvList()

            // 清空添加
            that.addFormchailvfei.reason = ''
            that.addFormchailvfei.ccdaybegin = ''
            that.addFormchailvfei.ccdayend = ''
            that.addFormchailvfei.ccdays = ''
            that.addFormchailvfei.ccattachmentnum = ''
            that.addFormchailvfei.chailvfeisub = []
            that.addFormchailvfei.money = 0
            that.addFormchailvfei.ccyuzhi = ''
            that.addFormchailvfei.cctuibu = ''
            that.addFormchailvfei.beizhu = ''
            that.addFormchailvfei.attachment = ''
            that.$refs.MultiImgOrPdf.cleardata()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelShenPiNewFyBxChaiLv: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        spid: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelShenPiNewFyBxChaiLv, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiNewFyBxChaiLvNum()
            that.apiGetShenPiNewFyBxChaiLvList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiShenPiBaoXiaoSH: function (okorno) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        spid: that.modelShenPi.spid,
        spopinion: that.modelShenPi.spopinion,
        moneytax: that.modelShenPi.moneytax,
        okorno: okorno
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(that.apiShenPiBaoXiaoSHUrl, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiNewFyBxChaiLvNum()
            that.apiGetShenPiNewFyBxChaiLvList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiShenPiNewFyBxChaiLvSH0: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        spid: that.modelSubmitAgain.spid,
        spreply: that.modelSubmitAgain.spreply
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ShenPiNewFyBxChaiLvSH0, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiNewFyBxChaiLvNum()
            that.apiGetShenPiNewFyBxChaiLvList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiShenPiNewFyBxChaiLvPrint: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        spid: that.modelSubmitAgain.spid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ShenPiNewFyBxChaiLvPrint, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiNewFyBxChaiLvList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetShenPiNewFyBxChaiLvLogList: function (orderid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: orderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiNewFyBxChaiLvLogList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dialogLogActivities = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.warntitle {
  margin-left: 65px;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
  color: rgb(127, 124, 126);
}

.productdata1 {
  padding-bottom: 20px;
}

.productdata2 {
  padding-bottom: 5px;
}

</style>
